import React, {useState} from "react";
import Article from "../common/Article";

const Preferences = (props) => {
  const [round, setRound] = useState(0);
  const [section, setSection] = useState("Development");
  const [title, setTitle] = useState("");

  return (
    <>
      <div className="setting authentication">
      <Article className="content" {...props}>


        <div className="navigation">

          <h3 className="headline">USER PREFERENCES</h3>

          <div className="navigation__unit">
            <h4>OPERATION SETTINGS</h4>
            <dl>
              <dt>Operation Modal Size</dt>
              <dd>Normal / Large</dd>
              <dt>Text Tooltip</dt>
              <dd>When enabled, a radio text tooltip will appear when mouse enters into a block.</dd>
              <dt>Lock On Auto Play</dt>
              <dd>When enabled, "Auto Play" is ON as default.</dd>
              <dt>Other User's Customclips</dt>
              <dd>When enabled, all user's customclips are shown.</dd>
            </dl>
          </div>


          <div className="navigation__unit">
            <h4>CREATE TIME-LINE</h4>
          </div>


          <div className="navigation__unit">
            <h4>GO TO PAST TIME-LINE</h4>
            <div className="input-group">
            </div>
          </div>



          <div className="back-button-area">
            <button className="back-button t-hover" onClick={props.handleBack}><span>BACK</span></button>
          </div>


        </div>


      </Article>
      </div>
    </>
  );
}

export default Preferences;
